<template>
  <LayoutMenuDesktopContainer>
    <template #left>
      <KeepAlive>
        <li
          v-for="(item, index) in formatEcosystemMenu"
          :key="hash(item)"
          class="mb-0.5 last:mb-0"
        >
          <MenuLink
            :data="item"
            :current="current === index"
            @click="handleClick(item, index)"
          />
        </li>
      </KeepAlive>
    </template>
    <template #right>
      <LayoutMenuDesktopContent
        v-if="currentData"
        :type="menuName.ECOSYSTEM"
        :link="currentData?.link"
      >
        <KeepAlive>
          <LayoutMenuDesktopCategory
            v-for="(item, index) in formatEcosystemMenu"
            v-show="current === index"
            :key="hash(item)"
            :list="item.subMenus"
          />
        </KeepAlive>
      </LayoutMenuDesktopContent>
    </template>
  </LayoutMenuDesktopContainer>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import MenuLink from '@/components/Layout/Menu/Desktop/MenuLink.vue';
  import validIsNuxtLink from '@/components/Layout/Menu/validIsNuxtLink';
  import type { IFormatMenu } from '@/stores/menuStore';

  const menuStore = useMenuStore();
  const { menuName, formatEcosystemMenu } = storeToRefs(menuStore);

  const current = ref<number>(0);

  const currentData = computed(
    (): IFormatMenu | null => formatEcosystemMenu.value[current.value] || null
  );

  const handleClick = (payload: IFormatMenu, index: number): void => {
    if (!validIsNuxtLink(payload)) {
      current.value = index;
    }

    window.gtag('event', 'site_click', {
      Item: 'Navigation',
      Item_Cate: menuName.value.ECOSYSTEM,
      Item_Name: payload.name,
    });
  };
</script>
